import { Component } from '@angular/core';
import { NavController, Events, LoadingController } from 'ionic-angular';
import { LoginWebPage } from '../login-web/login-web';
import { FoneCpfPage } from '../fonecpf/fonecpf';
import { BrComService } from '../../service/BrComService';
import { BrComDao } from '../../service/BrComDao';
import { IniciaPaginaService } from '../../service/IniciaPaginaService';

@Component({
  selector: 'page-home',
  templateUrl: 'home.html'
})
export class HomePage {

  constructor(private iniciaPaginaService: IniciaPaginaService, private brComService: BrComService, private brComDao: BrComDao, public nav: NavController, private events: Events, private loadingCtrl: LoadingController) {
    this.iniciaPaginaService.init();
    //this.mostraLoading();
    this.events.publish("iniciapagina:init", nav);

    let grupos = this.brComDao.obtemGrupos();
    if (grupos) {
      let temAutenticado = false;
      for (let grupo of grupos) {
        if (grupo['Autenticado'])
          temAutenticado = true;
      }
      this.brComService.iniciaPaginaInicial({});
    } else
      this.nav.setRoot(LoginWebPage);
  }

  mostraLoading() {
    this.loadingCtrl.create({
      content: 'Aguarde ...',
      duration: 1000
    }).present();
  }

}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts